import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'lib-component-loading-indicator',
  templateUrl: './component-loading-indicator.component.html',
  styleUrls: ['./component-loading-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent]
})
export class ComponentLoadingIndicatorComponent {

  @Input()
  public isVisible = false;
  @Input()
  public inline = false;

  constructor() { }
}
